// src/components/Navbar.jsx

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaSpotify, FaYoutube } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import './Navbar.css';

export default function Navigation({ userData, setUserData, setIsLogged, isLogged }) {
  const navigate = useNavigate();

  function handleLogOut() {
    localStorage.setItem("user", null);
    setUserData(null);
    setIsLogged(false);
    return navigate('login');
  }

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="mb-5 px-3">
      <Container>
        <Navbar.Brand as={Link} to={userData ? '/' : '/register'}>Noxe</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {userData && isLogged &&
              <>
                <Nav.Link as={Link} to="/">Home</Nav.Link>
                <Nav.Link as={Link} to="about">About</Nav.Link>
                <Nav.Link as={Link} to="contact">Contact</Nav.Link>
                <Nav.Link as={Link} to="people">People</Nav.Link>
                <Nav.Link as={Link} to="tv">Tv</Nav.Link>
                <Nav.Link as={Link} to="movies">Movies</Nav.Link>
              </>
            }
          </Nav>
          <Nav className="ms-auto">
            <div className="d-flex align-items-center">
              <Link className="text-white mx-2" to="#"><FaFacebookF /></Link>
              <Link className="text-white mx-2" to="#"><FaInstagram /></Link>
              <Link className="text-white mx-2" to="#"><FaTwitter /></Link>
              <Link className="text-white mx-2" to="#"><FaLinkedinIn /></Link>
              <Link className="text-white mx-2" to="#"><FaSpotify /></Link>
              <Link className="text-white mx-2" to="#"><FaYoutube /></Link>
            </div>
            {userData && isLogged ?
              <>
                <Nav.Link as={Link} to="profile">Profile</Nav.Link>
                <Nav.Link onClick={handleLogOut}>LogOut</Nav.Link>
              </> :
              <>
                <Nav.Link as={Link} to="login">Login</Nav.Link>
                <Nav.Link as={Link} to="register">Register</Nav.Link>
              </>
            }
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
